import { Injectable } from '@angular/core';
import type { MapboxGeoJSONFeature } from 'mapbox-gl';
import centroid from '@turf/centroid';
import { ReplaySubject } from 'rxjs';

export type TypeOfMap = 'report' | 'default';

@Injectable({
  providedIn: 'root',
})
export class MapBoxService {
  // map should be initialized after the html container is created,
  // so it is done in ngOnInit instead of constructor which requires adding !
  map!: mapboxgl.Map;
  reportsMap!: mapboxgl.Map;

  readonly mapReady$ = new ReplaySubject<boolean>(1);

  public getFeatureCenter(feature: MapboxGeoJSONFeature): any {
    //@ts-ignore
    const center = centroid(feature).geometry.coordinates;
    return center;
  }

  public flyToCurrentCenter(): void {
    this.map.flyTo({
      center: this.map.getCenter(),
    });
  }

  public simulateMapClick(center: number[]): void {
    // project lng/lat to pixel inside the canvas
    const centerPoint = this.map.project([center[0], center[1]]);

    // find the canvas element position in the page
    const canvas = this.map.getCanvas();
    const rect = canvas.getBoundingClientRect();

    // build a "page-relative" click at that spot
    const clickEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      // clientX/clientY must be relative to the viewport
      clientX: rect.left + centerPoint.x,
      clientY: rect.top + centerPoint.y,
    });

    // Simulate click event to select feature on screen
    canvas.dispatchEvent(clickEvent);
  }

  // Remove all markers from chosen map when it's impossible to target
  public removeAllMarkers(type: TypeOfMap): void {
    // Use "as any" to access private array of markers
    const map = this.getCurrentMap(type) as any;
    const markersArr = map._markers;

    if (markersArr.length > 0) {
      // Iteratively remove all markers
      markersArr.forEach((m: mapboxgl.Marker) => m.remove());
      markersArr.length = 0;
    }
  }

  // Convert TypeOfMap to actual instance of map
  public getCurrentMap(type: TypeOfMap): mapboxgl.Map {
    if (type === 'report') {
      return this.reportsMap;
    } else {
      return this.map;
    }
  }
}
